module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"views.dialogService.tabs.usage":"Usage","views.dialogService.tabs.carbon":"Emissions","views.dialogService.tabs.tags":"Record Tags","views.dialogService.tabs.virtualtags":"Virtual Tags","views.dialogService.tabs.annotations":"Annotations","views.dialogService.tabs.raw":"Raw Data"}}')
  delete Component.options._Ctor
}
